import { DragEvent, Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/FileDropZone/FileDropZone.styl'

type FileDropZoneState = {
  dragover: boolean
}

type FileDropZoneProps = {
  onFiles: (files: File[]) => void
  onUrl: (url: string) => void
}

export class FileDropZone extends Component<FileDropZoneProps, FileDropZoneState> {
  state = {
    dragover: false,
  }

  render () {
    const { dragover } = this.state
    const { children } = this.props
    const className = cn(
      styles.container,
      {
        [styles.dragover]: dragover,
      }
    )
    return (
      <div
        className={ className }
        onDragOver={ this.handleDragOver }
        onDragLeave={ this.handleDragLeave }
        onDrop={ this.handleDrop }
      >
        { children }
        <div className={ styles.fader }>
          <div className={ styles.faderContent }>Drop files here</div>
        </div>
      </div>
    )
  }

  private stopEvents (event: DragEvent<HTMLDivElement>) {
    event.preventDefault()
    event.stopPropagation()
  }

  private handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    this.stopEvents(event)
    this.setState({ dragover: true })
  }

  private handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    this.stopEvents(event)
    this.setState({ dragover: false })
  }

  private handleDrop = (event: DragEvent<HTMLDivElement>) => {
    this.stopEvents(event)
    const { onFiles, onUrl } = this.props
    const { dataTransfer } = event

    const files = Array.from(event.dataTransfer.files || [])
    if (onFiles && files.length) {
      onFiles(files)
    }

    const url = dataTransfer.getData('text/uri-list')
    if (url) {
      onUrl(url)
    }

    this.setState({ dragover: false })
  }
}
